import { string, func } from 'prop-types';

export const propTypes = {
  collectionName: string.isRequired
};